import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = (_: Theme) =>
  createStyles({
    createBtn: {
      height: 32,
      justifyContent: 'flex-start',
    },
    createBtnLabel: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  });
